import { Container } from '../components/Container'
import { Section } from '../components/Section'
import { EmptyState } from '../components/EmptyState'
import { Button, Flex } from '@chakra-ui/react'
import { Link, useNavigate } from 'react-router'
import { ArrowLeft } from '../icons'

export const NotFoundPage = () => {
  const navigate = useNavigate()

  return (
    <Section>
      <Container>
        <EmptyState
          title="Stránka nenalezena"
          cta={
            <Flex flexDir={'column'} gap={8} alignItems={'center'}>
              <Button as={Link} to="/" colorScheme="primary" px={6}>Zpět na nástěnku</Button>
              <Button
                variant="ghost"
                type="button"
                onClick={() => navigate(-1)}
              >
                <ArrowLeft color="secondary.500" />
                Zpět na předchozí stránku
              </Button>
            </Flex>
          }
        />
      </Container>
    </Section>
  )
}
